import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { getAppPermissions } from '@src/common/NavMenuLink/permissionsFunctions';
import { getUserPermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import {
  getAppLinkHandler,
  removeHashFromUrl,
} from '@sde/widgets-core/src/tools/linkHelperFunctions';
import { checkPermissionAndHandle } from './helpers/permissionHandler';

export const getAppLinkHandlerRightRails = (
  link,
  queryParam,
  queryParamData
) => {
  if (queryParam) {
    return removeHashFromUrl(
      link.replace(queryParam, queryParamData[queryParam])
    );
  }
  return link;
};

const FlexRow = styled('div', {
  display: 'inline-block',
  alignItems: 'flex-start',
  width: 'fit-content',
});

export const LinkFromHeaderContentLagoon = (props) => {
  const {
    name,
    href,
    queryParam,
    openInNewWindow,
    useAPIRedirect,
    isDownload,
    permission,
    onClick,
    toggleModal,
    user,
    isInternal,
  } = props;
  const { isSuperUser, isUhcInsightsUser } = user;

  const [appDSPermissions, setAppDSPermissions] = useState({});

  useEffect(() => {
    if (user && user.permissions) {
      setAppDSPermissions(getUserPermissions(user));
    }
  }, [user.permissions]);

  const queryParamData = {
    ...(user && { uuid: user.uuid }),
  };

  const redirect = getAppLinkHandlerRightRails(
    href,
    queryParam,
    queryParamData
  );

  // Handle permission checking and navigation on click
  const handleClick = () => {
    checkPermissionAndHandle({
      permission,
      appDSPermissions,
      toggleModal,
      name,
      onClick,
      isDownload,
      href,
      isSuperUser,
      isUhcInsightsUser,
      isInternal,
      redirect,
    });
  };

  const addLaunchIcon =
    openInNewWindow || useAPIRedirect || !redirect.includes('#');

  let updatedOpenInNewWindow = openInNewWindow ? true : null;

  if (useAPIRedirect || (!redirect.includes('#') && isSuperUser))
    updatedOpenInNewWindow = false;

  return (
    <React.Fragment>
      <Link
        fontWeight='bold'
        size='$md'
        css={{
          'abyss-link-icon': {
            display: 'none !important',
          },
          'abyss-link-root': {
            width: 'fit-content',
          },
        }}
        // this is specifically needed for formatting.
        // the abyss link centers links when no href and has a long title
        href={
          (isSuperUser || isUhcInsightsUser) && !isInternal
            ? '/'
            : removeHashFromUrl(redirect)
        }
        onClick={(e) => {
          e.preventDefault(); // Prevent default link navigation
          handleClick();
        }}
        openNewWindow={updatedOpenInNewWindow}
      >
        <FlexRow>
          {name}
          {addLaunchIcon && (
            <IconMaterial
              css={{ verticalAlign: 'sub', marginLeft: '4px' }}
              icon='launch'
              size='16px'
            />
          )}
        </FlexRow>
      </Link>
    </React.Fragment>
  );
};

LinkFromHeaderContentLagoon.propTypes = {
  name: PropTypes.string.isRequired,
  href: PropTypes.string,
  queryParam: PropTypes.string,
  openInNewWindow: PropTypes.bool,
  useAPIRedirect: PropTypes.bool,
  onClick: PropTypes.func,
  isDownload: PropTypes.bool,
  permission: PropTypes.string,
  toggleModal: PropTypes.func.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  isInternal: PropTypes.bool,
};

LinkFromHeaderContentLagoon.defaultProps = {
  href: '',
  queryParam: null,
  openInNewWindow: false,
  useAPIRedirect: false,
  isDownload: false,
  onClick: () => {},
  permission: '',
  isInternal: false,
};
